import { useMemo } from "react"
import { MaterialReactTable } from "material-react-table"
import { Button } from "@mui/material"
import { download } from "export-to-csv"
import { toast } from "react-toastify"
import { post } from "../../util/Axios"
import { useActivityLogs } from "../Hooks/Hooks"
import { LoggedInUser } from "../../types/types"

export interface ActivitiesViewProps {
  user: LoggedInUser
}

function ActivitiesView(props: ActivitiesViewProps) {

  const { data: activities, isLoading } = useActivityLogs()

  const exportActivities = (selectedIds: number[]) => {
    const allSelected = selectedIds.length === (activities?.length ?? 0)
    post('/activity-log/export', allSelected ? {} : { ids: selectedIds }).then(response => {
      download({})(response.data)
      toast.success("Rows exported successfully!")
    })
  }

  const columns = useMemo(() => [
    {
      accessorKey: 'id',
      header: 'ID',
      size: 75
    },
      {
      accessorKey: 'action',
      header: 'Action',
    },
    {
      accessorKey: 'activity_date',
      header: 'Date',
      size: 350,
      accessorFn: (value: any): Date => new Date(value.activity_date),
      Cell: ({ cell }: any) => cell.getValue().toLocaleString(),
      filterVariant: 'datetime-range' as const
    },
    {
      accessorKey: 'username',
      header: 'User',
      size: 150
    },
    {
      accessorKey: 'tenant_shortname',
      header: 'Tenant',
      size: 150
    },

  ], []);

  return (
    <div>
      <h1>{"Activity Log"}</h1>
      <MaterialReactTable
        columns={columns}
        data={activities ?? []}
        enableColumnResizing
        enableRowSelection
        initialState={{
          density: 'compact',
          showColumnFilters: true,
          pagination: { pageSize: 15, pageIndex: 0 },
          sorting: [{ id: 'activity_date', desc: true }]
        }}
        state={{ isLoading: isLoading }}
        columnResizeMode="onEnd"
        getRowId={(originalRow: any) => originalRow.id}
        renderTopToolbarCustomActions={({ table }) => (
          <Button
            variant="contained"
            disabled={table.getSelectedRowModel().rows.length === 0}
            onClick={() => exportActivities(table.getSelectedRowModel().rows.map(row => row.original.id))}
          >
            Export
          </Button>
        )}
      />
    </div>
  )
}

export default ActivitiesView;
